import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { useAttachmentUrls } from '@/hooks/useAttachmentUrls';
import { isResponseDisabledSelector } from '@/state/session';
import { Avatar } from '../Avatar/Avatar';
import { Audio } from './Audio';
import { File } from './File';
import { Image } from './Image';
import { ResponseWrapper } from './ResponseWrapper/ResponseWrapper';
import { Text } from './Text';
import { Video } from './Video';
import styles from './Message.module.scss';
const isMediaType = (type) => {
    return ['image', 'video', 'audio', 'file'].includes(type);
};
/**
 * Renders a media attachment based on its type
 */
const MediaRenderer = ({ attachment, avatar }) => {
    switch (attachment.type) {
        case 'video':
            return _jsx(Video, { url: attachment.url, name: attachment.title });
        case 'image':
            return _jsx(Image, { url: attachment.url, name: attachment.title });
        case 'file':
            return _jsx(File, { url: attachment.url, name: attachment.title });
        case 'audio':
            return _jsx(Audio, { avatar: avatar || '', url: attachment.url });
        default:
            return null;
    }
};
/**
 * Renders an agent's response event, handling both new and legacy formats
 */
export const AgentResponseEvent = ({ event }) => {
    var _a, _b;
    const isDisabled = useRecoilValue(isResponseDisabledSelector(event.event_id));
    const attachments = useMemo(() => { var _a; return ((_a = event.body) === null || _a === void 0 ? void 0 : _a.attachments) || []; }, [(_a = event.body) === null || _a === void 0 ? void 0 : _a.attachments]);
    const attachmentUrls = useAttachmentUrls(attachments);
    const normalizedAttachments = useMemo(() => attachments
        .map((attachment) => {
        if (!attachment.id)
            return null;
        const url = attachmentUrls[attachment.id];
        if (!url || !attachment.title || !isMediaType(attachment.type))
            return null;
        return {
            id: attachment.id,
            type: attachment.type,
            url,
            title: attachment.title,
        };
    })
        .filter((att) => att !== null), [attachments, attachmentUrls]);
    return (_jsxs(ResponseWrapper, { children: [_jsx(Avatar, { avatar: event.author_avatar }), _jsxs("div", { className: styles.agent, children: [((_b = event.body) === null || _b === void 0 ? void 0 : _b.text) && _jsx(Text, { event: event, disabled: isDisabled }), normalizedAttachments.map((attachment) => (_jsx(MediaRenderer, { attachment: attachment, avatar: event.author_avatar }, attachment.id)))] })] }));
};
